import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createFactoryMembership = (factoryMembership) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_CREATE,
  payload: {
    factoryMembership,
  },
});

export const deleteFactoryMembership = (id) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createFactoryMembershipRequested = (localId, data) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_CREATE_REQUESTED,
  payload: {
    localId,
    data,
  },
});

export const createFactoryMembershipSucceeded = (localId, factoryMembership) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_CREATE_SUCCEEDED,
  payload: {
    localId,
    factoryMembership,
  },
});

export const createFactoryMembershipFailed = (localId, error) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_CREATE_FAILED,
  payload: {
    localId,
    error,
  },
});

export const createFactoryMembershipReceived = (factoryMembership, user) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_CREATE_RECEIVED,
  payload: {
    factoryMembership,
    user,
  },
});

export const deleteFactoryMembershipRequested = (id) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteFactoryMembershipSucceeded = (factoryMembership) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_DELETE_SUCCEEDED,
  payload: {
    factoryMembership,
  },
});

export const deleteFactoryMembershipFailed = (id, error) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteFactoryMembershipReceived = (factoryMembership) => ({
  type: ActionTypes.FACTORY_MEMBERSHIP_DELETE_RECEIVED,
  payload: {
    factoryMembership,
  },
});
